// material-ui
import { Grid } from '@material-ui/core';
import React from 'react';

// api
import {
  EAllowStatus,
  ResourceActiveEnabled,
  SegmentTargetingOR,
} from '~/src/dash/api/console-api';
import {
  IContextualSegment,
  IContextualSegmentLabel,
  IGeneralResource,
  IThirdPartyContextualSegment,
  NO_MAX_CONTENT_LENGTH,
  NO_MIN_CONTENT_LENGTH,
} from '~/src/dash/api/contextual-segments';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
} from '~/src/dash/types/props';
// utils
import { decorate } from '~/src/dash/utils/decorator';
// views
import { ContextualSegmentSettingsView } from '~/src/dash/views/contextual-segments/contextual-segment-settings-view';

interface IProps extends IReduxActionProps, ISessionStateProps, IUserStateProps, IHistoryProps {}

export const ContextualSegmentSettingsNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps> {
    render() {
      return (
        <Grid>
          <ContextualSegmentSettingsView
            currentContextualSegment={
              {
                ID: 0,
                PublisherID: parseInt(this.props.session.publisher.ID, 10),
                Name: 'New Contextual Segment',
                Active: ResourceActiveEnabled,
                TargetingContentRating: '',
                TargetingContentRatingIsAllowed: EAllowStatus.ALLOW,
                TargetingContentGenre: '',
                TargetingContentGenreIsAllowed: EAllowStatus.ALLOW,
                MaxContentLength: NO_MAX_CONTENT_LENGTH, // for now, 210 is no max
                MinContentLength: NO_MIN_CONTENT_LENGTH, // for now, 0 is no min
                ThirdPartyTargetingType: SegmentTargetingOR,

                Deals: [] as IGeneralResource[],
                Headerbidders: [] as IGeneralResource[],
                AdserverCampaigns: [] as IGeneralResource[],
                ContextualSegmentLabels: [] as IContextualSegmentLabel[],
                ThirdPartyContextualSegments: [] as IThirdPartyContextualSegment[],
              } as IContextualSegment
            }
          />
        </Grid>
      );
    }
  },
);
